<template>
  <div class="chapter-color">
    <div class="py-10" id="kapitel3">
      <v-container>
        <v-row class="justify-center">
          <v-col cols="12" class="text-center">
            <div
              class="text-uppercase display-2 pa-6 hidden-sm-and-down"
              style="color: #2E3440"
            >
              Digitaler Reifegrad
            </div>
            <div
              class="text-uppercase headline pa-6 hidden-md-and-up"
              style="color: #2E3440"
            >
              Digitaler Reifegrad
            </div>

            <v-divider
              style="border-color: #9d0c4a; border-width: 5px; width:50%; display: inline-block; border-style: dotted none none none"
            ></v-divider>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <div class="component-color">
      <reifegrad></reifegrad>
      <stakeholder></stakeholder>
    </div>
  </div>
</template>

<script>
import Reifegrad from "@/components/topics/digitaleorgs/reifegrad.vue";
import Stakeholder from "@/components/topics/digitaleorgs/stakeholder.vue";

export default {
  name: "DigitaleOrganisationen",
  components: { Reifegrad, Stakeholder }
};
</script>

<style scoped>
.chapter-color {
  background-color: #fff;
  min-height: 20em;
}
.component-color {
  background-color: #fff;
}
</style>
